// File de notifications non bloquantes pour l'admin.
//
// Remplace les `alert()` natifs : ceux-ci gèlent le thread, ne se stylent pas, et
// sur tablette en cuisine ils s'interposent entre la personne en cuisine et son plan de travail.
// L'état est au niveau module (pas dans le composable) pour que tous les appelants
// partagent la même file, quel que soit l'endroit d'où ils la poussent.
import { ref } from 'vue';

const toasts = ref([]);
let seq = 0;

const DEFAULT_TIMEOUT = { error: 8000, success: 4000, info: 5000 };

function dismiss(id) {
  toasts.value = toasts.value.filter((t) => t.id !== id);
}

function push(type, message, timeout) {
  const text = typeof message === 'string' ? message : (message?.message || String(message || ''));
  if (!text) return null;
  const id = ++seq;
  toasts.value = [...toasts.value, { id, type, text }];
  const ms = timeout ?? DEFAULT_TIMEOUT[type] ?? 5000;
  // timeout 0 = notification persistante, refermée à la main.
  if (ms > 0) setTimeout(() => dismiss(id), ms);
  return id;
}

export function useToast() {
  return {
    toasts,
    dismiss,
    success: (message, timeout) => push('success', message, timeout),
    error: (message, timeout) => push('error', message, timeout),
    info: (message, timeout) => push('info', message, timeout)
  };
}
